module.exports = __webpack_public_path__ + "static/img/SJ.5314cfae.svg";